import { defaultReducers, defaultInitialState, IDefaultState } from "../../../../../redux/_common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import * as constants from "./constants";

interface IState extends IDefaultState<any, any, any> {
  [constants.TASKCATEGORY_TYPES_LOADING]: boolean;
  [constants.TASKCATEGORY_TYPES]: any[];
}

const initialState:IState = {
  ...defaultInitialState,
  [constants.TASKCATEGORY_TYPES_LOADING]: false,
  [constants.TASKCATEGORY_TYPES]: [],
};
const reducers = {
  ...defaultReducers,
  setTaskCategoryTypesLoading: (state:IState, action:PayloadAction<boolean>) => {
    state[constants.TASKCATEGORY_TYPES_LOADING] = action.payload;
  },
  setTaskCategoryTypes: (state:IState, action:PayloadAction<any[]>) => {
    state[constants.TASKCATEGORY_TYPES] = action.payload;
  }
};

export const taskCategoriesSlice = createSlice({
  name: "taskCategories",
  initialState,
  reducers,
});

